import React from "react";
import { OutlineButtons } from "./buttons";
import Image from "../../assets/img/undraw_void_-3-ggu 1.svg";
import { CONTACT_INFO } from "../../constants/support";
import PageLayout from "./PageLayout";

const NoAccessPage = ({ product = "Expireds" }) => {
  const handleCall = () => {
    // Use window.location to initiate the phone call
    window.location.href = CONTACT_INFO.PHONE_NUMBER_LINK;
  };
  return (
    <PageLayout>
      <section>
        <div className="flex justify-center items-center flex-col gap-[32px] py-3">
          <img className="h-[180px]" src={Image} alt="Description" />
          <div className=" text-center flex flex-col gap-2 items-center">
            <p className=" text-gray-secondary text-[24px]  font-semibold leading-6">
              You are not currently subscribed to {product}
            </p>
            <p className="text-[16px] leading-6 text-gray-secondary">
              To gain access to this data please contact a Landvoice Sales
              Representative at {CONTACT_INFO.PHONE_NUMBER}.
            </p>
            <div className=" w-[140px]">
              <OutlineButtons label={"Call Support"} onClick={handleCall} />
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default NoAccessPage;
